module.exports = __webpack_public_path__ + "img/table.b08d4bea.png";